module.exports = __webpack_public_path__ + "static/cake_lettering-5bc9eaa629a4e126b75179ebe7456369.jpg";